// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-box-2 {
    background-color: white;
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 5px 9.5px;
    border-radius: 30px;
    height: auto;
    min-height: 51px !important;
  }
  
  .comment-icon {
    height: 24px;
    width: 24px;
    cursor: pointer;
  }
  
  .comment-icon-two {
    background-color:white;
    cursor: pointer;
    /* padding: 13px; */
    border-radius: 50%;
    height: 51px;
    width: 51px;
    display:flex ;
    justify-content: center;
    align-items: center;
  }
  
  .comment-box-2 textarea[type="text"] {
    background-color:transparent;
    /* border: 0.5px solid #000000; */
    border: none;
    /* box-shadow:inset 0 0 8px 0px #00000040; */
    font-family: "Poppins";
    font-weight: 500;
    font-size: 12px;  
    border-radius: 5px;
    padding: 10.5px 0px 9.5px 16px;
    height: 41px;
    &:focus{
      outline: none;
    }
  } 
  .comment-box-2 input[type="text"] {
    background-color:transparent;
    /* border: 0.5px solid #000000; */
    border: none;
    /* box-shadow:inset 0 0 8px 0px #00000040; */
    font-family: "Poppins";
    font-weight: 500;
    font-size: 12px;  
    border-radius: 5px;
    padding: 9.5px 0px 9.5px 16px;
    height: 41px;
    &:focus{
      outline: none;
    }
  } 
  
  .mention-dropdown {
    position: absolute;
    bottom: 70px;
    z-index: 999;
    background: white;
    border: 1px solid #eee;
    width: 220px;
    border-radius: 16px;
    max-height: 220px;
    overflow-y: auto;
    box-shadow: 0px 6px 18px rgba(0,0,0,0.15);
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .mention-dropdown::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  .mention-option {
    padding: 10px 14px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap:12px;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mention-option img{
    height: 40px;
    width: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  .mention-initials {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #d9d9d9;
    color: #555;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    flex-shrink: 0;
  }
  
  
  .mention-option:hover {
    background: #e6e6e6;
  }
  
  .highlighted-text {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    white-space: pre-wrap;
    pointer-events: none;
    color: transparent;
    width: calc(100% - 60px);
    font-size: 14px;
    line-height: 1.2;
  }
  
  .highlighted-text .mention {
    color: #1976d2;
    font-weight: 600;
  }
  
  .comment-box-2::-webkit-scrollbar,
  input[type="text"]::-webkit-scrollbar,
  textarea[type="text"]::-webkit-scrollbar,
  .mention-dropdown::-webkit-scrollbar,
  .emoji-dropdown::-webkit-scrollbar
  {
    display: none;
  }`, "",{"version":3,"sources":["webpack://./src/components/ui/commentInput/commentInputStyle.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,iCAAiC;IACjC,YAAY;IACZ,4CAA4C;IAC5C,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ;MACE,aAAa;IACf;EACF;EACA;IACE,4BAA4B;IAC5B,iCAAiC;IACjC,YAAY;IACZ,4CAA4C;IAC5C,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ;MACE,aAAa;IACf;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;;;;IAME,aAAa;EACf","sourcesContent":[".comment-box-2 {\n    background-color: white;\n    display: flex;\n    gap: 5px;\n    align-items: center;\n    padding: 5px 9.5px;\n    border-radius: 30px;\n    height: auto;\n    min-height: 51px !important;\n  }\n  \n  .comment-icon {\n    height: 24px;\n    width: 24px;\n    cursor: pointer;\n  }\n  \n  .comment-icon-two {\n    background-color:white;\n    cursor: pointer;\n    /* padding: 13px; */\n    border-radius: 50%;\n    height: 51px;\n    width: 51px;\n    display:flex ;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .comment-box-2 textarea[type=\"text\"] {\n    background-color:transparent;\n    /* border: 0.5px solid #000000; */\n    border: none;\n    /* box-shadow:inset 0 0 8px 0px #00000040; */\n    font-family: \"Poppins\";\n    font-weight: 500;\n    font-size: 12px;  \n    border-radius: 5px;\n    padding: 10.5px 0px 9.5px 16px;\n    height: 41px;\n    &:focus{\n      outline: none;\n    }\n  } \n  .comment-box-2 input[type=\"text\"] {\n    background-color:transparent;\n    /* border: 0.5px solid #000000; */\n    border: none;\n    /* box-shadow:inset 0 0 8px 0px #00000040; */\n    font-family: \"Poppins\";\n    font-weight: 500;\n    font-size: 12px;  \n    border-radius: 5px;\n    padding: 9.5px 0px 9.5px 16px;\n    height: 41px;\n    &:focus{\n      outline: none;\n    }\n  } \n  \n  .mention-dropdown {\n    position: absolute;\n    bottom: 70px;\n    z-index: 999;\n    background: white;\n    border: 1px solid #eee;\n    width: 220px;\n    border-radius: 16px;\n    max-height: 220px;\n    overflow-y: auto;\n    box-shadow: 0px 6px 18px rgba(0,0,0,0.15);\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .mention-dropdown::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    height: 0;\n  }\n\n  .mention-option {\n    padding: 10px 14px;\n    cursor: pointer;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap:12px;\n    color: #000;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .mention-option img{\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n\n  .mention-initials {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #d9d9d9;\n    color: #555;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 14px;\n    flex-shrink: 0;\n  }\n  \n  \n  .mention-option:hover {\n    background: #e6e6e6;\n  }\n  \n  .highlighted-text {\n    position: absolute;\n    top: 50%;\n    left: 12px;\n    transform: translateY(-50%);\n    white-space: pre-wrap;\n    pointer-events: none;\n    color: transparent;\n    width: calc(100% - 60px);\n    font-size: 14px;\n    line-height: 1.2;\n  }\n  \n  .highlighted-text .mention {\n    color: #1976d2;\n    font-weight: 600;\n  }\n  \n  .comment-box-2::-webkit-scrollbar,\n  input[type=\"text\"]::-webkit-scrollbar,\n  textarea[type=\"text\"]::-webkit-scrollbar,\n  .mention-dropdown::-webkit-scrollbar,\n  .emoji-dropdown::-webkit-scrollbar\n  {\n    display: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
